import { observer } from "mobx-react";
import React from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import {
  Paper,
  Title,
  Slider,
  Checkbox,
  TextInput,
  Button,
  Text,
  Anchor,
  NumberFormatter,
  Center,
  Stack,
} from "@mantine/core";
import { darkStyles, JsonView, collapseAllNested } from "react-json-view-lite";
const expandToLevel4 = (level) => level <= 4;
import "react-json-view-lite/dist/index.css";
const CreateOrderForm: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    // Define the three marks: min, default, max
    const marks = [
      // { value: getAChannel.minChannelSize, label: "150,000 sats" }, // Minimum
      // { value: 1000000 }, // Default
      // { value: getAChannel.maxChannelSize, label: "16,000,000 sats" }, // Maximum
    ];

    const onGetPriceClick = () => {
      console.log("get price click in component");
      getAChannel.createOrder();
    };
    return (
      <Paper withBorder p="md">
        <Title order={4}>Choose A Channel Size</Title>

        <Text size="sm" c="dimmed">
          - we recommend a channel size of at least 1,000,000 satoshis
        </Text>
        <Text size="sm" c="dimmed">
          - channels are guaranteed to stay open for 3 months
        </Text>
        <Text size="sm" c="dimmed">
          - send or receive one payment at least once every thirty days to keep
          channel open indefinitely
        </Text>

        <Slider
          min={getAChannel.minChannelSize} // 150,000
          max={getAChannel.maxChannelSize} // 16,000,000
          value={getAChannel.channelSize}
          onChange={(value) => getAChannel.setChannelSize(value)}
          label={(value) => `${value.toLocaleString()} sats`} // Format with commas
          mt="md"
          color="blue"
          marks={marks}
          defaultValue={1000000} // Default to 1,000,000
          step={50000} // Step of 50,000 for smooth increments
        />
        <Center>
          <Title order={3}>
            <NumberFormatter
              value={getAChannel.channelSize}
              thousandSeparator
              suffix=" satoshis"
            />
          </Title>
        </Center>
        <Checkbox
          label="Zero-Confirmation Channel"
          checked={getAChannel.useZeroConf}
          onChange={(event) =>
            getAChannel.setUseZeroConf(event.currentTarget.checked)
          }
          mt="md"
        />
        {getAChannel.useZeroConf && (
          <Text size="sm" c="dimmed" mt="xs">
            Zero-confirmation channels are available to use immediately. Your
            node configuration will almost certainly need to be tweaked to
            permit this. See{" "}
            <Anchor
              target="_blank"
              href="https://docs.lightning.engineering/lightning-network-tools/pool/zero-confirmation-channels"
            >
              LND docs
            </Anchor>{" "}
            and{" "}
            <Anchor
              target="_blank"
              href="https://lightningdevkit.org/blog/zero-confirmation-channels/"
            >
              LDK docs
            </Anchor>
            .
          </Text>
        )}
        <Checkbox
          label="Private Channel"
          checked={getAChannel.isPrivateChannel}
          onChange={(event) =>
            getAChannel.setIsPrivateChannel(event.currentTarget.checked)
          }
          disabled={getAChannel.isPrivateChannelDisabled}
          mt="md"
        />
        {getAChannel.isPrivateChannelDisabled && (
          <Text size="sm" c="dimmed" mt="xs">
            Zero-confirmation channels must be private.
          </Text>
        )}
        {!getAChannel.isPrivateChannel &&
          !getAChannel.isPrivateChannelDisabled && (
            <Text size="sm" c="dimmed" mt="xs">
              If your channel is not private, it will be visible to everyone on
              the Lightning Network. This is good if you want to route payments
              to other nodes, or if you want to receive Keysends. Otherwise,
              keep it private.
            </Text>
          )}

        <TextInput
          label="Your Node's Public Key"
          value={getAChannel.publicKey}
          onChange={(event) =>
            getAChannel.setPublicKey(event.currentTarget.value)
          }
          mt="md"
          error={getAChannel.errorMessageForPublicKey}
          placeholder="e.g., 02a98c86ef366ce226a..."
        />
        <Button
          disabled={!getAChannel.userHasInputtedValidPublicKey}
          onClick={() => onGetPriceClick()}
          mt="md"
        >
          Get Price
        </Button>

        {getAChannel.orderErrored && (
          <Stack>
            <Text mt="md" c="red">
              Something went wrong. Maybe this error message will help....
            </Text>
            <JsonView
              data={getAChannel.orderError.data.error}
              shouldExpandNode={expandToLevel4}
              style={darkStyles}
            />
            <Button
              onClick={() => getAChannel.resetGetAChannelToDefaultValues()}
              mt="md"
            >
              Start Over
            </Button>
          </Stack>
        )}
      </Paper>
    );
  }
);

export default CreateOrderForm;
